async function $7698bc61d28469d1$export$f1a9d67ab940fad5(word) {
    const url = `https://api.dictionaryapi.dev/api/v2/entries/en/${word}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
}


function $34ed92c22e798cb4$export$6832043222fab376(title, meaning) {
    if (title && meaning && meaning !== "No definition found.") {
        const synth = window.speechSynthesis;
        synth.cancel(); // Cancel any ongoing speech
        const utterance = new SpeechSynthesisUtterance(`${title}. ${meaning}`);
        synth.speak(utterance);
    }
}


const $1225a0ff24304843$var$inputEl = document.getElementById("input");
const $1225a0ff24304843$var$infoTextEl = document.getElementById("info-text");
const $1225a0ff24304843$var$meaningContainerEl = document.getElementById("meaning-container");
const $1225a0ff24304843$var$titleEl = document.getElementById("title");
const $1225a0ff24304843$var$phoneticEl = document.getElementById("phonetic");
const $1225a0ff24304843$var$partOfSpeechEl = document.getElementById("part-of-speech");
const $1225a0ff24304843$var$meaningEl = document.getElementById("meaning");
const $1225a0ff24304843$var$exampleEl = document.getElementById("example");
const $1225a0ff24304843$var$audioEl = document.getElementById("audio");
const $1225a0ff24304843$var$audioGroupEl = document.getElementById("audio-group");
const $1225a0ff24304843$var$historyListEl = document.getElementById("history-list"); // Fix #1: element now exists in HTML
const $1225a0ff24304843$var$historyPanelEl = document.getElementById("history-panel"); // Fix #1: show panel once history exists
const $1225a0ff24304843$var$speakBtn = document.getElementById("speak-btn");
let $1225a0ff24304843$var$searchHistory = [];
async function $1225a0ff24304843$var$handleSearch(word) {
    if (!word.trim()) return;
    try {
        // Show loading state
        $1225a0ff24304843$var$infoTextEl.style.display = "block";
        $1225a0ff24304843$var$meaningContainerEl.style.display = "none";
        $1225a0ff24304843$var$infoTextEl.innerHTML = `<p>Searching the meaning of <strong>"${word}"</strong>...</p>`;
        const result = await (0, $7698bc61d28469d1$export$f1a9d67ab940fad5)(word);
        if (result.title) {
            // Word not found
            $1225a0ff24304843$var$meaningContainerEl.style.display = "block";
            $1225a0ff24304843$var$infoTextEl.style.display = "none";
            $1225a0ff24304843$var$titleEl.innerText = word;
            if ($1225a0ff24304843$var$phoneticEl) $1225a0ff24304843$var$phoneticEl.innerText = '';
            if ($1225a0ff24304843$var$partOfSpeechEl) $1225a0ff24304843$var$partOfSpeechEl.innerText = '';
            $1225a0ff24304843$var$meaningEl.innerText = "No definition found for this word.";
            $1225a0ff24304843$var$exampleEl.innerText = "Try checking the spelling and searching again.";
            $1225a0ff24304843$var$audioGroupEl.style.display = "none";
            $1225a0ff24304843$var$speakBtn.style.display = "none";
        } else {
            // Success
            $1225a0ff24304843$var$infoTextEl.style.display = "none";
            $1225a0ff24304843$var$meaningContainerEl.style.display = "block";
            $1225a0ff24304843$var$speakBtn.style.display = "flex";
            $1225a0ff24304843$var$titleEl.innerText = result[0].word;
            // Update phonetic tag
            const phonetic = result[0].phonetic || result[0].phonetics?.find((p)=>p.text)?.text || '';
            if ($1225a0ff24304843$var$phoneticEl) $1225a0ff24304843$var$phoneticEl.innerText = phonetic;
            // Update part of speech tag
            const pos = result[0].meanings?.[0]?.partOfSpeech || '';
            if ($1225a0ff24304843$var$partOfSpeechEl) $1225a0ff24304843$var$partOfSpeechEl.innerText = pos;
            $1225a0ff24304843$var$meaningEl.innerText = result[0].meanings[0].definitions[0].definition;
            const example = result[0].meanings[0].definitions[0].example;
            $1225a0ff24304843$var$exampleEl.innerText = example ? `"${example}"` : "No example available.";
            // Find audio
            const phonetics = result[0].phonetics.find((p)=>p.audio);
            if (phonetics && phonetics.audio) {
                $1225a0ff24304843$var$audioEl.src = phonetics.audio;
                $1225a0ff24304843$var$audioGroupEl.style.display = "block";
            } else $1225a0ff24304843$var$audioGroupEl.style.display = "none";
        }
        $1225a0ff24304843$var$addToHistory(word);
    } catch (error) {
        console.error(error);
        $1225a0ff24304843$var$infoTextEl.innerHTML = `<p style="color: var(--clr-danger);">Network error \u{2014} please check your connection and try again.</p>`;
        $1225a0ff24304843$var$infoTextEl.style.display = "block";
    }
}
function $1225a0ff24304843$var$addToHistory(word) {
    const normalised = word.toLowerCase().trim();
    if (!$1225a0ff24304843$var$searchHistory.includes(normalised)) {
        $1225a0ff24304843$var$searchHistory.unshift(normalised);
        // Keep only last 10
        if ($1225a0ff24304843$var$searchHistory.length > 10) $1225a0ff24304843$var$searchHistory.pop();
        $1225a0ff24304843$var$renderHistory();
    }
}
function $1225a0ff24304843$var$renderHistory() {
    if (!$1225a0ff24304843$var$historyListEl) return;
    $1225a0ff24304843$var$historyListEl.innerHTML = "";
    // Fix #1: Show the history panel once there are items
    if ($1225a0ff24304843$var$historyPanelEl) $1225a0ff24304843$var$historyPanelEl.style.display = $1225a0ff24304843$var$searchHistory.length ? "block" : "none";
    $1225a0ff24304843$var$searchHistory.forEach((word)=>{
        const li = document.createElement("li");
        li.textContent = word;
        li.addEventListener('click', ()=>{
            $1225a0ff24304843$var$inputEl.value = word;
            $1225a0ff24304843$var$handleSearch(word);
        });
        $1225a0ff24304843$var$historyListEl.appendChild(li);
    });
}
$1225a0ff24304843$var$inputEl.addEventListener("keyup", (e)=>{
    if (e.target.value && e.key === "Enter") $1225a0ff24304843$var$handleSearch(e.target.value.trim());
});
$1225a0ff24304843$var$speakBtn.addEventListener("click", ()=>{
    (0, $34ed92c22e798cb4$export$6832043222fab376)($1225a0ff24304843$var$titleEl.innerText, $1225a0ff24304843$var$meaningEl.innerText);
});


//# sourceMappingURL=dictionary.58ad278c.js.map
